import { useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { PROPERTY_TYPE_LABELS } from "@/lib/realestateConstants";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const Field = ({ label, children }) => <div className="space-y-1.5"><Label className="text-xs">{label}</Label>{children}</div>;

export const EditPropertyDialog = ({ property, open, onOpenChange, onChanged }) => {
  const [form, setForm] = useState({
    title: property.title, address: property.address || "", city: property.city || "", property_type: property.property_type,
    price: property.price ?? "", surface_m2: property.surface_m2 ?? "", catastro_ref: property.catastro_ref || "", notes: property.notes || "",
  });
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e?.target ? e.target.value : e });

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.put(`/properties/${property.id}`, {
        ...form, price: form.price === "" ? null : Number(form.price), surface_m2: form.surface_m2 === "" ? null : Number(form.surface_m2),
      });
      toast.success("Inmueble actualizado");
      onOpenChange(false);
      onChanged();
    } catch (err) { toast.error(apiError(err)); } finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg max-h-[90vh] overflow-y-auto" data-testid="edit-property-dialog">
        <DialogHeader><DialogTitle>Editar inmueble</DialogTitle><DialogDescription>{property.ref}</DialogDescription></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <Field label="Título *"><Input data-testid="edit-property-title" value={form.title} onChange={set("title")} required maxLength={120} /></Field>
          <div className="grid grid-cols-2 gap-3">
            <Field label="Dirección"><Input value={form.address} onChange={set("address")} /></Field>
            <Field label="Ciudad"><Input value={form.city} onChange={set("city")} /></Field>
            <Field label="Tipo">
              <Select value={form.property_type} onValueChange={set("property_type")}>
                <SelectTrigger><SelectValue /></SelectTrigger>
                <SelectContent>{Object.entries(PROPERTY_TYPE_LABELS).map(([k, v]) => <SelectItem key={k} value={k}>{v}</SelectItem>)}</SelectContent>
              </Select>
            </Field>
            <Field label="Precio (€)"><Input data-testid="edit-property-price" type="number" min="0" value={form.price} onChange={set("price")} /></Field>
            <Field label="Superficie (m²)"><Input type="number" min="0" value={form.surface_m2} onChange={set("surface_m2")} /></Field>
            <Field label="Ref. catastral"><Input value={form.catastro_ref} onChange={set("catastro_ref")} maxLength={40} /></Field>
          </div>
          <Field label="Notas internas"><Textarea value={form.notes} onChange={set("notes")} rows={3} /></Field>
          <div className="flex justify-end gap-2">
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
            <Button type="submit" disabled={saving} data-testid="edit-property-submit">{saving ? "Guardando…" : "Guardar cambios"}</Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
